<div class="fixed inset-x-0 z-[60]" [style.top.px]="topOffsetPx" [style.bottom.px]="bottomOffsetPx">
    <!-- Click fuera para cerrar -->
    <div class="absolute inset-0 bg-[rgba(0,0,0,0.70)] touch-none" (click)="close()" aria-hidden="true"></div>

    <div class="relative mx-auto h-full w-full max-w-[1280px] pointer-events-none">
        <!-- DESKTOP -->
        <section class="pointer-events-auto hidden lg:flex absolute right-0 top-0 max-h-full w-[335px]
             bg-white p-[30px] flex-col gap-1
             overflow-y-auto overscroll-contain
             border-l-[0.4px] border-[#DDDDE3]" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="menuContent"></ng-container>
        </section>

        <!-- TABLET + MOBILE -->
        <section class="pointer-events-auto lg:hidden absolute inset-0 bg-white flex flex-col
             overflow-y-auto overscroll-contain" (click)="$event.stopPropagation()">
            <div class="p-4 sm:p-[30px] flex flex-col gap-1" [ngClass]="lockerHelpOpen ? 'md:pl-[365px]' : quoteHelpOpen ? 'md:pl-[calc(50%+20px)]' : ''">
                <ng-container *ngTemplateOutlet="menuContent"></ng-container>
            </div>
        </section>

        <!--  MODAL: ¿Cómo lo debo escribir?  -->

        <!-- DESKTOP  -->
        <section *ngIf="lockerHelpOpen" class="pointer-events-auto hidden lg:flex absolute top-0 max-h-full w-[335px] bg-white p-[30px]
             overflow-y-auto overscroll-contain border-l-[0.4px] border-[#DDDDE3]" style="right: 335px;"
            (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="lockerHelpTpl"></ng-container>
        </section>

        <!-- TABLET -->
        <section *ngIf="lockerHelpOpen" class="pointer-events-auto hidden md:flex lg:hidden absolute inset-y-0 left-0 w-[335px] bg-neutral-color-neutral-2 p-[30px]
             overflow-y-auto overscroll-contain border-r-[0.4px] border-[#DDDDE3]" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="lockerHelpTpl"></ng-container>
        </section>

        <!-- MOBILE -->
        <section *ngIf="lockerHelpOpen" class="pointer-events-auto md:hidden absolute inset-0 bg-white p-[30px]
             overflow-y-auto overscroll-contain" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="lockerHelpTpl"></ng-container>
        </section>

        <!--  PANEL: ¿Cómo cotizar?  -->

        <!-- DESKTOP -->
        <section *ngIf="quoteHelpOpen" class="pointer-events-auto hidden lg:flex absolute top-0 max-h-full w-[335px] bg-white p-[30px]
             overflow-y-auto overscroll-contain border-l-[0.4px] border-[#DDDDE3]" style="right: 335px;"
            (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="quoteHelpTpl"></ng-container>
        </section>

        <!-- TABLET -->
        <section *ngIf="quoteHelpOpen" class="pointer-events-auto hidden md:flex lg:hidden absolute inset-y-0 left-0 w-1/2 bg-neutral-color-neutral-2 p-[30px]
             overflow-y-auto overscroll-contain border-r-[0.4px] border-[#DDDDE3]" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="quoteHelpTpl"></ng-container>
        </section>

        <!-- MOBILE -->
        <section *ngIf="quoteHelpOpen" class="pointer-events-auto md:hidden absolute inset-0 bg-white p-[30px]
             overflow-y-auto overscroll-contain" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="quoteHelpTpl"></ng-container>
        </section>
    </div>
</div>

<!--  CONTENIDO DEL MENU  -->
<ng-template #menuContent>
    <!-- Header -->
    <div class="flex items-center justify-between">
        <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
            {{ (isAuthenticated() ? 'MENU.GREETING' : 'MENU.GREETING_GUEST') | translate:{ name: userName } }}
        </p>

        <button type="button" class="bg-[#1C2024] p-2 rounded-[4px] flex items-center justify-center cursor-pointer" (click)="close()"
            [attr.aria-label]="'MENU.CLOSE' | translate">
            <img [src]="icons.close" alt="" aria-hidden="true" class="w-[12px] h-[12px] block" />
        </button>
    </div>

    <div class="py-[10px]">
        <div class="h-px w-full bg-[rgba(1,1,46,0.13)]"></div>
    </div>

    <!-- Dirección de casillero -->

    <div class="py-1 flex flex-col gap-[12px]">
        <!-- HEADER con padding -->
        <button type="button" class="w-full flex items-center justify-between px-4 py-2 rounded-[4px] text-left cursor-pointer transition-colors duration-200 hover:bg-neutral-color-neutral-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-color-accent-10 focus-visible:ring-offset-2" (click)="toggleLocker()">
            <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.LOCKER.TITLE' | translate }}
            </p>

            <img [src]="icons.chevron" alt="" aria-hidden="true" class="w-[12px] h-[12px] block transition-transform"
                [class.rotate-180]="lockerExpanded" />
        </button>

        <div *ngIf="lockerExpanded" class="flex flex-col gap-2 px-0">
            <!-- Mapa -->
            <div class="pt-[10px]">
                <a [href]="lockerAddress().mapHref" target="_blank" rel="noopener noreferrer"
                    class="group block w-full rounded-[4px] overflow-hidden cursor-pointer transition-all duration-200 ease-out hover:-translate-y-[1px] hover:shadow-[0_8px_18px_var(--Neutral-color-Neutral-12-Alpha-18)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-color-accent-10 focus-visible:ring-offset-2"
                    [attr.aria-label]="'MENU.LOCKER.TITLE' | translate">
                    <img [src]="lockerMapImages.desktop" [alt]="'MENU.LOCKER.TITLE' | translate"
                        class="hidden lg:block w-full h-auto object-contain transition-transform duration-200 ease-out group-hover:scale-[1.015]" />
                    <img [src]="lockerMapImages.tablet" [alt]="'MENU.LOCKER.TITLE' | translate"
                        class="hidden md:block lg:hidden w-full h-auto object-contain transition-transform duration-200 ease-out group-hover:scale-[1.015]" />
                    <img [src]="lockerMapImages.mobile" [alt]="'MENU.LOCKER.TITLE' | translate"
                        class="block md:hidden w-full h-auto object-contain transition-transform duration-200 ease-out group-hover:scale-[1.015]" />
                </a>
            </div>

            <!-- Campos de dirección -->
            <div class="flex flex-col gap-2">
                <!-- Dirección -->
                <div class="flex items-center justify-between gap-3">
                    <p
                        class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                        {{ 'MENU.LOCKER.ADDRESS' | translate }}
                    </p>
                    <button type="button"
                        class="bg-[#F2F2F5] rounded-[4px] h-[32px] px-2 flex items-center copy-chip gap-1 shrink-0 cursor-pointer hover:bg-[#E8E8EB]"
                        (click)="copyToClipboard(lockerAddress().line, 'MENU.LOCKER.ADDRESS_COPIED')" [attr.aria-label]="'MENU.LOCKER.COPY_ADDRESS_ARIA' | translate">
                        <div class="w-6 h-6 flex items-center justify-center shrink-0">
                            <img [src]="icons.copy" alt="" aria-hidden="true" class="w-[18px] h-[18px] block" />
                        </div>
                        <span
                            class="font-inter font-medium text-[11px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                            {{ lockerAddress().line }}
                        </span>
                    </button>
                </div>

                <!-- Nombre del envío -->
                <div class="flex items-center justify-between gap-3">
                    <p
                        class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                        {{ 'MENU.LOCKER.SHIPPING_NAME' | translate }}
                    </p>
                    <button *ngIf="isAuthenticated(); else shippingNameGuest" type="button"
                        class="bg-[#F2F2F5] rounded-[4px] h-[32px] px-2 copy-chip flex items-center gap-1 min-w-0 cursor-pointer hover:bg-[#E8E8EB]"
                        (click)="copyToClipboard(shippingName, 'MENU.LOCKER.SHIPPING_NAME_COPIED')" [attr.aria-label]="'MENU.LOCKER.COPY_SHIPPING_NAME_ARIA' | translate">
                        <div class="w-6 h-6 flex items-center justify-center shrink-0">
                            <img [src]="icons.copy" alt="" aria-hidden="true" class="w-[18px] h-[18px] block" />
                        </div>
                        <span
                            class="font-inter font-medium text-[11px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate max-w-[140px]">
                            {{ shippingName }}
                        </span>
                    </button>
                    <ng-template #shippingNameGuest>
                        <div class="bg-[#F2F2F5] rounded-[4px] h-[32px] px-2 flex items-center gap-1 min-w-0 opacity-60 cursor-not-allowed"
                            aria-disabled="true">
                            <div class="w-6 h-6 flex items-center justify-center shrink-0">
                                <img [src]="icons.copy" alt="" aria-hidden="true" class="w-[18px] h-[18px] block" />
                            </div>
                            <span
                                class="font-inter font-medium text-[9px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate max-w-[140px]">
                                {{ 'MENU.LOCKER.SHIPPING_NAME_GUEST' | translate }}
                            </span>
                        </div>
                    </ng-template>
                </div>

                <!-- Estado y ciudad -->
                <div class="flex items-center justify-between gap-3">
                    <p
                        class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                        {{ 'MENU.LOCKER.STATE_CITY' | translate }}
                    </p>
                    <button type="button"
                        class="bg-[#F2F2F5] rounded-[4px] h-[32px] px-2 copy-chip flex items-center gap-1 shrink-0 cursor-pointer hover:bg-[#E8E8EB]"
                        (click)="copyToClipboard(lockerAddress().cityState, 'MENU.LOCKER.STATE_CITY_COPIED')" [attr.aria-label]="'MENU.LOCKER.COPY_STATE_CITY_ARIA' | translate">
                        <div class="w-6 h-6 flex items-center justify-center shrink-0">
                            <img [src]="icons.copy" alt="" aria-hidden="true" class="w-[18px] h-[18px] block" />
                        </div>
                        <span
                            class="font-inter font-medium text-[11px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                            {{ lockerAddress().cityState }}
                        </span>
                    </button>
                </div>

                <!-- Código postal -->
                <div class="flex items-center justify-between gap-3">
                    <p
                        class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                        {{ 'MENU.LOCKER.ZIP_CODE' | translate }}
                    </p>
                    <button type="button"
                        class="bg-[#F2F2F5] rounded-[4px] h-[32px] px-2 copy-chip flex items-center gap-1 shrink-0 cursor-pointer hover:bg-[#E8E8EB]"
                        (click)="copyToClipboard(lockerAddress().zip, 'MENU.LOCKER.ZIP_CODE_COPIED')" [attr.aria-label]="'MENU.LOCKER.COPY_ZIP_CODE_ARIA' | translate">
                        <div class="w-6 h-6 flex items-center justify-center shrink-0">
                            <img [src]="icons.copy" alt="" aria-hidden="true" class="w-[18px] h-[18px] block" />
                        </div>
                        <span
                            class="font-inter font-medium text-[11px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                            {{ lockerAddress().zip }}
                        </span>
                    </button>
                </div>
            </div>

            <!-- Botón ¿Cómo lo debo escribir? -->
            <div class="py-4">
                <button type="button" class="w-full flex items-center justify-start rounded-[4px] cursor-pointer"
                    (click)="openLockerHelp()">
                    <span class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#3A5CCC]">
                        {{ 'MENU.LOCKER.HOW_TO_WRITE' | translate }}
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="py-[10px]">
        <div class="h-px w-full bg-[rgba(1,1,46,0.13)]"></div>
    </div>

    <!-- Moneda -->
    <div class="px-4 py-1 flex flex-col gap-[12px]">
        <button type="button" class="w-full flex items-center justify-between py-2 rounded-[4px] text-left cursor-pointer transition-colors duration-200 hover:bg-neutral-color-neutral-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-color-accent-10 focus-visible:ring-offset-2" (click)="toggleCurrency()">
            <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.CURRENCY.TITLE' | translate }}: <span class="font-inter font-medium">{{ currencyLabel | translate }}</span>
            </p>
            <img [src]="icons.chevron" alt="" aria-hidden="true" class="w-[12px] h-[12px] block transition-transform"
                [class.rotate-180]="currencyExpanded" />
        </button>

        <div *ngIf="currencyExpanded" class="flex flex-col gap-[12px]">
            <p class="font-inter font-medium text-[11px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.CURRENCY.DESCRIPTION' | translate }}
            </p>

            <div class="flex gap-[14px] items-start flex-wrap">
                <button *ngFor="let c of currencyOptions" type="button" class="rounded-[4px] p-[8px] overflow-hidden cursor-pointer"
                    [ngClass]="c.key === currencyKey() ? 'bg-[#BDEE63]' : 'bg-[#F0F4FF]'"
                    (click)="setCurrency(c.key)">
                    <span
                        class="font-inter font-semibold text-[12px] leading-[16px] tracking-[0.04px] whitespace-nowrap"
                        [ngClass]="c.key === currencyKey() ? 'text-[#37401C]' : 'text-[#1C2024]'">
                        {{ c.code }}
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="py-[10px]">
        <div class="h-px w-full bg-[rgba(1,1,46,0.13)]"></div>
    </div>

    <!-- Idioma  -->
    <div class="px-4 py-1 flex flex-col gap-[12px] ">
        <button type="button" class="w-full flex items-center justify-between py-2 rounded-[4px] text-left cursor-pointer transition-colors duration-200 hover:bg-neutral-color-neutral-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-color-accent-10 focus-visible:ring-offset-2" (click)="toggleLanguage()">
            <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.LANGUAGE.TITLE' | translate }}:
                <span class="font-inter font-medium">{{ languageLabel | translate }}</span>
            </p>

            <img [src]="icons.chevron" alt="" aria-hidden="true" class="w-[12px] h-[12px] block transition-transform"
                [class.rotate-180]="languageExpanded" />
        </button>

        <div *ngIf="languageExpanded" class="flex flex-col gap-[12px]">
            <p class="font-inter font-medium text-[11px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.LANGUAGE.DESCRIPTION' | translate }}
            </p>

            <div class="flex gap-[14px] items-start flex-wrap">
                <button *ngFor="let l of languageOptions" type="button"
                    class="rounded-[4px] px-2 overflow-hidden h-[32px] cursor-pointer"
                    [ngClass]="l.key === languageKey ? 'bg-[#BDEE63]' : 'bg-[#F0F4FF]'" (click)="setLanguage(l.key)">
                    <span
                        class="font-inter font-semibold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                        {{ l.label | translate }}
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="py-[10px]">
        <div class="h-px w-full bg-[rgba(1,1,46,0.13)]"></div>
    </div>

    <!-- País destino  -->
    <div class="px-4 py-1 flex flex-col gap-3">
        <button type="button" class="w-full flex items-center justify-between py-2 rounded-[4px] text-left cursor-pointer transition-colors duration-200 hover:bg-neutral-color-neutral-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-color-accent-10 focus-visible:ring-offset-2" (click)="toggleDestination()">
            <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.DESTINATION.TITLE' | translate }}:
                <span class="font-inter font-medium">{{ destinationCountryLabel }}</span>
            </p>

            <!-- chevron  -->
            <img [src]="icons.chevron" alt="" aria-hidden="true" class="w-[12px] h-[12px] block transition-transform"
                [class.rotate-180]="destinationExpanded" />
        </button>

        <!-- Contenido desplegado -->
        <div *ngIf="destinationExpanded" class="flex flex-col gap-3">
            <p class="font-inter font-medium text-[11px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.DESTINATION.DESCRIPTION' | translate }}
            </p>

            <div class="flex gap-3 items-start">
                <button *ngFor="let c of destinationCountries" type="button" class="rounded-[4px] p-2 overflow-hidden cursor-pointer"
                    [ngClass]="c.key === destinationCountryKey ? 'bg-[#BDEE63]' : 'bg-[#F0F4FF]'"
                    (click)="setDestinationCountry(c.key)">
                    <div class="flex items-center gap-2">
                        <img [src]="c.flagSrc" alt="" aria-hidden="true"
                            class="w-[21px] h-[15px] rounded-[3px] object-cover" />
                        <span
                            class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                            {{ c.label }}
                        </span>
                    </div>
                </button>
            </div>
        </div>
    </div>

    <div class="py-[10px]">
        <div class="h-px w-full bg-[rgba(1,1,46,0.13)]"></div>
    </div>

    <!-- Ayuda y configuración  -->
    <div class="px-4 py-1 flex flex-col gap-3">
        <button type="button" class="w-full flex items-center justify-between py-2 rounded-[4px] cursor-pointer transition-colors duration-200 hover:bg-neutral-color-neutral-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-color-accent-10 focus-visible:ring-offset-2" (click)="toggleHelp()">
            <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.HELP.TITLE' | translate }}
            </p>

            <!-- chevron  -->
            <img [src]="icons.chevron" alt="" aria-hidden="true" class="w-[12px] h-[12px] block transition-transform"
                [class.rotate-180]="helpExpanded" />
        </button>

        <div *ngIf="helpExpanded" class="flex flex-col">
            <a [attr.href]="customerServiceUrl || null" target="_blank" rel="noopener noreferrer"
                class="block w-full py-4 rounded-[4px] text-left cursor-pointer hover:bg-[#F9F9FB]">
                <span class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                    {{ 'MENU.HELP.CUSTOMER_SERVICE' | translate }}
                </span>
            </a>

            <button type="button" class="w-full py-4 rounded-[4px] text-left cursor-pointer hover:bg-[#F9F9FB]"
                (click)="openQuoteHelp()">
                <span class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                    {{ 'MENU.HELP.HOW_TO_QUOTE' | translate }}
                </span>
            </button>

            <!-- <button type="button" class="w-full  py-4 rounded-[4px] text-left hover:bg-[#F9F9FB]"
                (click)="emit('how_to_ship')">
                <span class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                    ¿Cómo enviar?
                </span>
            </button> -->

            <a *ngIf="isAuthenticated()" routerLink="/account" (click)="close()"
                class="block w-full py-4 rounded-[4px] text-left cursor-pointer hover:bg-[#F9F9FB]">
                <span class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                    {{ 'MENU.HELP.MY_ACCOUNT' | translate }}
                </span>
            </a>

            @if (isAuthenticated()) {
                <button type="button" class="w-full py-4 rounded-[4px] text-left cursor-pointer hover:bg-[#F9F9FB]"
                    (click)="emit('logout')">
                    <span class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                        {{ 'MENU.HELP.LOGOUT' | translate }}
                    </span>
                </button>
            } @else {
                <a routerLink="/auth/login" (click)="close()"
                    class="block w-full py-4 rounded-[4px] text-left cursor-pointer hover:bg-[#F9F9FB]">
                    <span class="font-inter font-medium text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                        {{ 'MENU.HELP.LOGIN' | translate }}
                    </span>
                </a>
            }
        </div>
    </div>
</ng-template>

<!--  TEMPLATE: ¿Cómo cotizar?  -->
<ng-template #quoteHelpTpl>
    <div class="flex flex-col w-full gap-1">
        <div class="flex items-center justify-between">
            <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                {{ 'MENU.HELP.HOW_TO_QUOTE' | translate }}
            </p>
            <button type="button" class="p-2 rounded-[4px] flex items-center justify-center cursor-pointer"
                (click)="closeQuoteHelp()" [attr.aria-label]="'MENU.CLOSE' | translate">
                <img [src]="icons.drop" alt="" aria-hidden="true" class="w-[12px] h-[12px] block" />
            </button>
        </div>

        <div class="py-[10px]">
            <div class="h-px w-full bg-[rgba(1,1,46,0.13)]"></div>
        </div>

        <div class="py-1">
            <video class="w-full rounded-[4px] block"
                   [src]="quoteHelpVideoSrc"
                   controls
                   playsinline>
            </video>
        </div>
    </div>
</ng-template>

<!--  TEMPLATE: ¿Cómo lo debo escribir?  -->
<ng-template #lockerHelpTpl>
    <div class="flex flex-col w-full gap-1">
        <div class="flex items-center justify-between">
            <p
                class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] whitespace-nowrap">
                {{ 'MENU.LOCKER.HELP_TITLE' | translate }}
            </p>

            <button type="button" class="p-2 rounded-[4px] flex items-center justify-center cursor-pointer" (click)="closeLockerHelp()"
                [attr.aria-label]="'MENU.CLOSE' | translate">
                <img [src]="icons.drop" alt="" aria-hidden="true" class="w-[12px] h-[12px] block" />
            </button>
        </div>

        <div class="py-[10px]">
            <div class="h-px w-full bg-[rgba(1,1,46,0.13)]"></div>
        </div>

        <div class="py-1 flex flex-col gap-3">
            <p class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                {{ 'MENU.LOCKER.TITLE' | translate }}
            </p>

            <!-- Formulario de ejemplo (solo lectura) -->
            <form class="flex flex-col gap-[14px]" aria-readonly="true" (submit)="$event.preventDefault()">
                <!-- País o región -->
                <div class="flex flex-col gap-[6px]">
                    <label class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                        {{ 'MENU.LOCKER.FORM.COUNTRY_LABEL' | translate }}
                    </label>
                    <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                        <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                            {{ 'MENU.LOCKER.FORM.COUNTRY_VALUE' | translate }}
                        </span>
                    </div>
                </div>

                <!-- Nombre completo -->
                <div class="flex flex-col gap-[6px]">
                    <label class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                        {{ 'MENU.LOCKER.FORM.FULL_NAME_LABEL' | translate }}
                    </label>
                    <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                        <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                            {{ isAuthenticated() ? shippingName : ('MENU.LOCKER.FORM.FULL_NAME_VALUE' | translate) }}
                        </span>
                    </div>
                </div>

                <!-- Número de teléfono -->
                <div class="flex flex-col gap-[6px]">
                    <label class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                        {{ 'MENU.LOCKER.FORM.PHONE_LABEL' | translate }}
                    </label>
                    <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                        <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                            {{ 'MENU.LOCKER.FORM.PHONE_VALUE' | translate }}
                        </span>
                    </div>
                    <p class="font-inter font-normal text-[11px] leading-[16px] tracking-[0.04px] text-[#6B6B70]">
                        {{ 'MENU.LOCKER.FORM.PHONE_HINT' | translate }}
                    </p>
                </div>

                <!-- Dirección -->
                <div class="flex flex-col gap-[6px]">
                    <label class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024]">
                        {{ 'MENU.LOCKER.FORM.ADDRESS_LABEL' | translate }}
                    </label>
                    <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                        <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                            {{ 'MENU.LOCKER.FORM.ADDRESS_VALUE' | translate }}
                        </span>
                    </div>
                    <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                        <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                            {{ 'MENU.LOCKER.FORM.ADDRESS_LINE2' | translate }}
                        </span>
                    </div>
                </div>

                <!-- Ciudad / Estado / Código Postal -->
                <div class="grid grid-cols-3 gap-[8px]">
                    <!-- Ciudad -->
                    <div class="flex flex-col gap-[6px] min-w-0">
                        <label class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] min-h-[36px]">
                            {{ 'MENU.LOCKER.FORM.CITY_LABEL' | translate }}
                        </label>
                        <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                            <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                                {{ 'MENU.LOCKER.FORM.CITY_VALUE' | translate }}
                            </span>
                        </div>
                    </div>

                    <!-- Estado -->
                    <div class="flex flex-col gap-[6px] min-w-0">
                        <label class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] min-h-[36px]">
                            {{ 'MENU.LOCKER.FORM.STATE_LABEL' | translate }}
                        </label>
                        <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                            <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                                {{ 'MENU.LOCKER.FORM.STATE_VALUE' | translate }}
                            </span>
                        </div>
                    </div>

                    <!-- Código Postal -->
                    <div class="flex flex-col gap-[6px] min-w-0">
                        <label class="font-inter font-bold text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] min-h-[36px]">
                            {{ 'MENU.LOCKER.FORM.ZIP_LABEL' | translate }}
                        </label>
                        <div class="h-[38px] rounded-[6px] border border-[#DDDDE3] bg-white flex items-center px-3">
                            <span class="font-inter font-normal text-[12px] leading-[18px] tracking-[0.04px] text-[#1C2024] truncate">
                                {{ 'MENU.LOCKER.FORM.ZIP_VALUE' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>
